import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { API } from "../../lib/api";

export default function BusinessForgotPasswordPage() {
  const nav = useNavigate();
  const [email, setEmail] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [done, setDone] = React.useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/business/auth/forgot`, { email });
      setDone(true);
    } catch {
      // Forgot endpoint always returns ok, but in case of network error:
      setDone(true);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-brand-bg2 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <h1 className="font-display font-bold text-2xl text-brand-dark text-center mb-4">Glemt kodeord</h1>
        <div className="bg-white border border-brand p-6">
          {done ? (
            <div className="space-y-3 text-sm" data-testid="business-forgot-done">
              <p>Hvis emailen findes i vores system, sender vi et reset-link inden for få minutter.</p>
              <p className="text-brand-text2 text-xs">Tjek også din spam-folder. Linket udløber om 60 minutter.</p>
              <Link to="/business/login" className="btn-secondary w-full justify-center inline-flex mt-3">Tilbage til login</Link>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-4">
              <p className="text-sm text-brand-text2">Indtast din email — vi sender et link til at vælge nyt kodeord.</p>
              <div>
                <label className="label-flat">Email</label>
                <input className="input-flat" type="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} data-testid="business-forgot-email"/>
              </div>
              <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="business-forgot-submit">
                {busy ? <Loader2 className="animate-spin" size={16}/> : "Send reset-link"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
